import * as React from "react";
import { cn } from "@/lib/utils";
interface BrushButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
  children: React.ReactNode;
  asChild?: boolean;
}
const BrushButton = React.forwardRef<HTMLButtonElement, BrushButtonProps>(({
  className,
  variant = "primary",
  children,
  asChild,
  ...props
}, ref) => {
  const baseStyles = `
      relative inline-flex items-center justify-center
      px-7 py-4 text-body font-bold text-white
      transition-all duration-200 ease-out
      cursor-pointer border-none outline-none
      transform hover:scale-[1.02] active:scale-[0.98]
    `;
  const variantStyles = {
    primary: "bg-sunset-600 hover:bg-sunset-700",
    secondary: "bg-forest-700 hover:bg-forest-800"
  };
  return <button ref={ref} className={cn(baseStyles, variantStyles[variant], "brush-button", className)} {...props}>
        {/* Brush texture overlay */}
        <span className="absolute inset-0 opacity-20 pointer-events-none brush-texture" />
        
        {/* Text content */}
        <span className="relative z-10 drop-shadow-sm my-0 mx-0 py-0 pr-0 text-center px-0">{children}</span>
      </button>;
});
BrushButton.displayName = "BrushButton";
export { BrushButton };